import api from "../../axios";

export const patchMailVerification = async (iUserId) => {
  const aResponse = await api.patch(`/users/${iUserId}/mail-verification`, {});
  return aResponse.data;
};
